import React from 'react'

// The catalogue data is free to use with attribution, so anywhere a
// catalogue-derived suggestion is shown to a person has to carry it.
//
// The sentence comes from the payload rather than being hardcoded here, so
// refreshing the snapshot can change it without a web release.
export default function Attribution({ text }) {
  if (!text) return null
  return <p className="curation-attribution text-muted small mb-0">{text}</p>
}
